import { useState, useEffect } from "react";
import Select from "react-select";


import logger from "../../utils/logger";
function CountrySelector({
  name = "countrySelect",
  inputId,
  data,
  onDataChange,
  required,
  label,
  allowUnknown = false,
  disabled = false,
}) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("/countries.json")
      .then((res) => res.json())
      .then((list) => {
        const sorted = list.sort((a, b) => a.name.localeCompare(b.name));
        if (allowUnknown) sorted.push({ code: "XX", name: "Nieznany" });
        setCountries(
          sorted.map((c) => ({
            value: c.code,
            label: `${c.name} (${c.code})`,
            _name: c.name,
          }))
        );
      })
      .catch(logger.error)
      .finally(() => setLoading(false));
  }, [allowUnknown]);

  const selected = countries.find((c) => c.value === data) || null;

  const filterOption = (option, rawInput) => {
    const q = rawInput.trim().toLowerCase();
    if (!q) return true;
    return (
      option.data._name.toLowerCase().includes(q) ||
      option.data.value.toLowerCase().includes(q)
    );
  };

  const styles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#F9FBFD",
      minHeight: "calc(1.5em + .75rem + 2px)",
      borderRadius: ".5rem",
      borderColor: state.isFocused ? "#86b7fe" : "#E3EBF6",
      boxShadow: state.isFocused ? "0 0 0 .25rem rgba(13,110,253,.25)" : "none",
      ":hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
      fontSize: "1rem",
    }),
    valueContainer: (base) => ({ ...base, padding: "0 .75rem" }),
    indicatorsContainer: (base) => ({ ...base, paddingRight: ".25rem" }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#e7f1ff"
        : state.isFocused
        ? "#f2f7ff"
        : "white",
      color: "#212529",
      cursor: "pointer",
    }),
    placeholder: (base) => ({ ...base, color: "#6c757d" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div>
      <label className="form-label" htmlFor={inputId}>
        {label}
        {required === "true" ? " *" : ""}
      </label>

      <Select
        inputId={inputId}
        classNamePrefix="rs-country"
        styles={styles}
        options={countries}
        value={selected}
        onChange={(opt) =>
          onDataChange({ target: { name, value: opt?.value ?? "" } })
        }
        placeholder="Wybierz..."
        isClearable
        isDisabled={disabled}
        isLoading={loading}
        filterOption={filterOption}
        noOptionsMessage={() => "Brak wyników"}
        components={{ IndicatorSeparator: null }}
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
      />
    </div>
  );
}

export default CountrySelector;


